import { env } from "./EnvironmentConfig";
export default {
  appointment_api_url: env.appointment_api_url,
  symptoms_api_url: env.symptoms_api_url,
  examination_api_url: env.examination_api_url,
  diagnosis_api_url: env.diagnosis_api_url,
  advice_api_url: env.advice_api_url,
  investigation_api_url: env.investigation_api_url,
  medication_api_url: env.medication_api_url,
  vitals_api_url: env.vitals_api_url,
  casemanager_api_url: env.casemanager_api_url,
  printsettings_api_url: env.printsettings_api_url,
  medicalhistory_api_url: env.medicalhistory_api_url,
  videolibrary_api_url: env.videolibrary_api_url,
  sso_to_pm_url: env.sso_to_pm_url,
  sso_to_pm_admin_url: env.sso_to_pm_admin_url,
  sso_to_pm_username: env.sso_to_pm_username,
  sso_to_pm_password: env.sso_to_pm_password,
  doctor_website_url: env.doctor_website_url,
  vaccination_api_url: env.vaccination_api_url,
  GROWTHBOOK_CLIENTKEY: env.GROWTHBOOK_CLIENTKEY,
  growth_chart_api_url: env.growth_chart_api_url,
  firebaseApiKey: env.firebaseApiKey,
  firebaseAuthDomain: env.firebaseAuthDomain,
  firebaseDatabaseURL: env.firebaseDatabaseURL,
  firebaseProjectId: env.firebaseProjectId,
  firebaseStorageBucket: env.firebaseStorageBucket,
  firebaseMessagingSenderId: env.firebaseMessagingSenderId,
  firebaseAppId: env.firebaseAppId,
  tatvaRedirect: env.tatvaRedirect,
  gynec_api_url: env.gynec_api_url,
  obstetric_api_url: env.obstetric_api_url,
  zydus_api_url: env.zydus_api_url,
  zydus_business_id: env.zydus_business_id,
  zydus_proxy_url: env.zydus_proxy_url,
  rx_digitization: env.rx_digitization,
  visit_api_url: env.visit_api_url,
  user_management_api_url: env.user_management_api_url,
  razorpay_integration_url: env.razorpay_integration_url,
  api_secret_key: env.api_secret_key,
  api_key: env.api_key,
  lab_params_api_url: env.lab_params_api_url,
  upload_doc_api_url: env.upload_doc_api_url,
  central_auth_api_url: env.central_auth_api_url,
  pedia_logout_url: env.pedia_logout_url,
  bulk_messages: env.bulk_messages,
  searchengine_url: env.searchengine_url,
  razorPay_key: env.razorPay_key,
  tatvaAi_api_url: env.tatvaAi_api_url,
  tatvaAi_url : env.tatvaAi_url,
  tatvaAi_logout_url: env.tatvaAi_logout_url,
  lite_api_key: env.lite_api_key,
  lite_secret_key: env.lite_secret_key,
  gen_rx_api_url: env.gen_rx_api_url,
  tatvaPedia_api_url: env.tatvaPedia_api_url,
  tatvaPedia_domain_url: env.tatvaPedia_domain_url,
};
